(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const url = new URL(window.location.href);

    if (url.searchParams.get('filter.v.availability') === '1') {
      return;
    }

    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    const url = new URL(window.location.href);

    if (!url.searchParams.has('q') || url.searchParams.get('filter.v.availability') === '1') {
      return;
    }

    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  })();

  (function () {
    const el = document.querySelector('.search-heading__typed');
    if (!el) return;
    const text = el.dataset.text;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = text;
      return;
    }
    let i = 0;
    let last = 0;
    const speed = 60;
    function tick(ts) {
      if (i >= text.length) return;
      if (ts - last >= speed) {
        el.textContent += text[i++];
        last = ts;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  } catch(e) { console.error(e); }
})();
})();
